var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('v-container',{staticStyle:{"max-width":"600px"}},[_c('p',{staticClass:"title my-2"},[_vm._v("Payment Method")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }